export default __webpack_public_path__ + "static/Lesser_Antidote-d8d54f71edb0153da26ae6d810d89bb4.png";